"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.createStreetView = createStreetView;
exports.loadGoogle = loadGoogle;

var _googleMaps = _interopRequireDefault(require("@sparefoot/google-maps"));

var googleLoadPromise;

function loadGoogle() {
  googleLoadPromise = new Promise(function (resolve) {
    _googleMaps["default"].load(function (google) {
      return resolve(google);
    });
  });
}

function createStreetView(element, config) {
  if (!googleLoadPromise) {
    loadGoogle();
  }

  return googleLoadPromise.then(function (google) {
    var coordinates = new google.maps.LatLng(config.latitude, config.longitude);
    var streetViewClient = new google.maps.StreetViewService();
    return new Promise(function (resolve, reject) {
      streetViewClient.getPanoramaByLocation(coordinates, 50, function (data, status) {
        if (status !== google.maps.StreetViewStatus.OK) {
          reject(status);
        } else {
          var panoramaOptions = {
            position: coordinates
          };

          if (config.yaw) {
            panoramaOptions.pov = {
              heading: config.yaw,
              pitch: config.pitch,
              zoom: config.xoom
            };
          }

          var panorama = new google.maps.StreetViewPanorama(element, panoramaOptions);
          resolve(panorama);
        }
      });
    });
  });
}